import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  ReferenceLine,
} from "recharts";


import WaterUseBreakdownChart from "../WaterUseBreakdownChart";

import { FaWater, FaChartLine, FaIndustry } from "react-icons/fa";
import { PieChart, Pie, Cell } from "recharts";
import "./WaterReport1.css";

const trendData = [
  { year: "2015", value: 242 },
  { year: "2019", value: 223 },
  { year: "2020", value: 256 },
  { year: "2023", value: 207 },
  { year: "2030", value: 202 },
];

const renderGoalLineLabel = ({ viewBox }) => {
  if (!viewBox) return null;

  return (
    <text
      x={viewBox.x - 12}
      y={viewBox.y - 8}
      fill="#2563eb"
      fontSize={12}
      fontWeight={700}
      textAnchor="end"
    >
      2030 Goal
    </text>
  );
};
const pieData = [
  { name: "Agriculture", value: 75, fill: "#4d8b2c" },
  { name: "Outdoor Residential", value: 10.5, fill: "#2a9d8f" },
  { name: "Indoor Residential", value: 7, fill: "#5fa8d3" },
  { name: "Commercial", value: 2.75, fill: "#e08e2b" },
  { name: "Institutional", value: 2.5, fill: "#64748b" },
  { name: "Industrial", value: 2.25, fill: "#c0562b" },
];

const renderCustomLabel = (props) => {
  const { cx, cy, midAngle, outerRadius, name, value } = props;
  const RADIAN = Math.PI / 180;

  const x = cx + (outerRadius + 20) * Math.cos(-midAngle * RADIAN);
  const y = cy + (outerRadius + 20) * Math.sin(-midAngle * RADIAN);

  const isAgriculture = name === "Agriculture";

  return (
    <text
      x={x}
      y={y}
      textAnchor={x > cx ? "start" : "end"}
      fill="#334155"
      fontSize={isAgriculture ? 15 : 12}
      fontWeight={isAgriculture ? 700 : 400} // 👈 key change
    >
      {name} {value}%
    </text>
  );
};

const WaterReport1 = () => {
  const miTotal = pieData
    .filter((d) => d.name !== "Agriculture")
    .reduce((sum, d) => sum + d.value, 0);

  return (
    <div className="report-wrapper">
      {/* HEADER */}
      <div className="report-header">
        <h1>
          {" "}
          <FaWater /> Water Usage per Capita
        </h1>
        <p>
          This report shows water consumption trends and sector distribution,
          helping track progress toward the 2030 efficiency goal.
        </p>
      </div>

      {/* KPI */}
      <div className="kpi-row">
        <div className="kpi blue">
          <h2>242 GPCD</h2>
          <p>Baseline (2015)</p>
        </div>

        <div className="kpi red">
          <h2>256 GPCD</h2>
          <p>Peak (2020)</p>
        </div>

        <div className="kpi green">
          <h2>207 GPCD</h2>
          <p>Current (2023)</p>
        </div>

        <div className="kpi purple">
          <h2>202 GPCD</h2>
          <p>Goal (2030)</p>
        </div>
      </div>

      {/* TREND */}
      <div className="sec-card-together">
        {" "}
        <div className="section-card">
          <h3>
            <FaChartLine /> Water Usage Trend
          </h3>

          <ResponsiveContainer width="100%" height={320}>
            <AreaChart
              data={trendData}
              margin={{ top: 20, right: 20, left: 40, bottom: 20 }}
            >
              <defs>
                <linearGradient id="colorTrend">
                  <stop offset="5%" stopColor="#6366f1" stopOpacity={0.5} />
                  <stop offset="95%" stopColor="#6366f1" stopOpacity={0} />
                </linearGradient>
              </defs>

              <CartesianGrid strokeDasharray="3 3" opacity={0.1} />

              <XAxis
                dataKey="year"
                stroke="#555"
                // padding={{ left: 6, right: 18 }}
                label={{
                  value: "Year",
                  position: "insideBottom",
                  offset: -5,
                  style: { fill: "#555", fontSize: 12 },
                }}
              />

              <YAxis
                stroke="#555"
                width={52}
                label={{
                  value: "GPCD",
                  angle: -90,
                  position: "insideLeft",
                  style: { fill: "#555", fontSize: 12 },
                }}
              />

              <Tooltip formatter={(value) => `${value} GPCD`} />

              {/* ✅ Goal Line */}
              {/* <ReferenceLine
                y={202}
                stroke="#2563eb"
                strokeDasharray="5 5"
                label={{
                  value: "2030 Goal",
                  position: "left",
                  offset: 15,
                  dy: -10,
                  fill: "#2563eb",
                  fontSize: 12,
                  fontWeight: 600,
                }}
              /> */}

              <ReferenceLine
                y={202}
                stroke="#2563eb"
                strokeWidth={2}
                strokeDasharray="8 6"
                ifOverflow="extendDomain"
                label={renderGoalLineLabel}
              />

              <Area
                type="monotone"
                dataKey="value"
                stroke="#6366f1"
                fill="url(#colorTrend)"
              />
            </AreaChart>
          </ResponsiveContainer>
          <p style={{ fontSize: "15px" }}>
            <b>Note:</b> The goal for 2030 is 202 GPCD.
          </p>
        </div>
      </div>

      <div className="mt-5">
        <WaterUseBreakdownChart compact />
      </div>
    </div>
  );
};

export default WaterReport1;
